<template>
  <page-block full-page>
    <page-content-placeholder text="404. Страница не найдена" max-width="640px" :img-src="Placeholder">
      <div class="paragraph-m_h mt-1">
        Возможно, адрес страницы некорректный или&nbsp;устарел.<br />
        Вернитесь на <router-link :to="{ name: RouteNames.Home }" class="link">гланую страницу</router-link>
      </div>
    </page-content-placeholder>
  </page-block>
</template>

<script lang="ts" setup>
import Placeholder from '@/assets/img/layouts/404-placeholder-image.svg';
import PageContentPlaceholder from '@/core/components/common/PageContentPlaceholder.vue';
import PageBlock from '@/core/components/interface/PageBlock.vue';
import { RouteNames } from '@/core/plugins/router/routeNames';
</script>

<style lang="scss" scoped></style>
